import { render, staticRenderFns } from "./ItinevertResultView.vue?vue&type=template&id=473e13d1&scoped=true"
import script from "./ItinevertResultView.vue?vue&type=script&lang=js"
export * from "./ItinevertResultView.vue?vue&type=script&lang=js"
import style0 from "./ItinevertResultView.vue?vue&type=style&index=0&id=473e13d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473e13d1",
  null
  
)

export default component.exports